import { render, staticRenderFns } from "./LogOut.html?vue&type=template&id=12953b5a&scoped=true&"
import script from "./LogOut.js?vue&type=script&lang=js&"
export * from "./LogOut.js?vue&type=script&lang=js&"
import style0 from "./LogOut.scss?vue&type=style&index=0&id=12953b5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12953b5a",
  null
  
)

export default component.exports